'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inheritsLoose = require('@babel/runtime/helpers/inheritsLoose');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var DocumentTitle = require('react-document-title');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DocumentTitle__default = /*#__PURE__*/_interopDefaultLegacy(DocumentTitle);

var WithTitle = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose__default["default"](WithTitle, _PureComponent);

  function WithTitle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          title = _this$props.title;
      return /*#__PURE__*/React__default["default"].createElement(DocumentTitle__default["default"], {
        title: title ? title + " | Tyro Health" : 'Tyro Health Online'
      }, /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, children));
    });

    return _this;
  }

  return WithTitle;
}(React.PureComponent);

_defineProperty__default["default"](WithTitle, "defaultProps", {
  title: null
});

exports["default"] = WithTitle;
